import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const MoreResults = <FormattedMessage {...commonMessages.moreResults} />;
